import React from 'react';
import { func, oneOf, string } from 'prop-types';
import { useSelector } from 'react-redux';

import { useStageCenteredPosition } from 'src/hooks';
import { DESIGN_COMPONENT_TYPE } from 'src/constants/general';
import { AddObjectCombination } from './add-object-combination';
import styles from './ObjectCombinations.module.scss';

const PREVIEW_AMOUNT = 4;

const ObjectCombinations = ({ title, type, onClickSeeAll }) => {
  const { objectCombinations } = useSelector(({ canvas }) => ({
    objectCombinations: canvas.objectCombinations,
  }));

  const position = useStageCenteredPosition();

  const objectsToShow = objectCombinations.filter(o => o.type === type).slice(0, PREVIEW_AMOUNT);

  return (
    <div className={styles.combinations}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        <button className={styles.seeAll} onClick={onClickSeeAll}>
          See all
        </button>
      </div>
      <div className={styles.content}>
        {objectsToShow.map(text => (
          <AddObjectCombination {...text} position={position} key={text.id} />
        ))}
      </div>
    </div>
  );
};

ObjectCombinations.propTypes = {
  type: oneOf(Object.values(DESIGN_COMPONENT_TYPE)),
  title: string.isRequired,
  onClickSeeAll: func.isRequired,
};

export { ObjectCombinations };
